// ==================== Mengenrabatt-Staffel: rechnen und bedienen ====================
// Gehoert ans ENDE von snippets/smattex-brand.liquid in ein eigenes script-Element, neben
// die anderen Produktseiten-Skripte (UVP-Umschalter, 15-Uhr-Cutoff).
//
// Warum die Logik hier und nicht im Snippet: Das Snippet rendert je Produktseite, dieses
// Skript soll genau einmal geladen werden. Im Snippet steht nur der Dreizeiler, der
// "sx-mr--js" setzt — der MUSS dort stehen, weil er ohne Flackern beim Parsen laufen muss.
(function () {
  'use strict';

  var eigenerSchreibvorgang = false;

  // IMMER frisch suchen, nie zwischenspeichern: Horizon rendert den Kaufblock beim
  // Variantenwechsel serverseitig neu und morpht ihn ein — eine gemerkte Referenz zeigt
  // danach auf einen Knoten, der nicht mehr im Dokument haengt, und das Setzen der Menge
  // liefe still ins Leere.
  function mengenfeld() {
    return document.querySelector('.product-details input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
  }

  function variantenfeld() {
    return document.querySelector('.product-details input[name="id"], form[action*="/cart/add"] input[name="id"]');
  }

  function zahl(wert, ersatz) {
    var n = parseInt(wert, 10);
    return isNaN(n) ? ersatz : n;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (z) {
      return z === '&' ? '&' : z === '<' ? '<' : z === '>' ? '>' : '"';
    });
  }

  // ---------------------------------------------------------------- Geldformat
  // Das Format wird NICHT fest auf de-DE verdrahtet, sondern aus dem Muster gelesen, das
  // Liquid mit dem money-Filter geliefert hat ("1.000,00 EUR"). So bleiben die Betraege in
  // der Bilanzzeile deckungsgleich mit den serverseitig gerenderten Preisen daneben —
  // auch wenn der Shop das Waehrungsformat einmal aendert.
  var formate = {};

  function formatLesen(muster) {
    var m = String(muster || '');
    var start = m.search(/\d/);
    if (start < 0) return null;
    var ende = m.length - 1;
    while (ende >= 0 && !/\d/.test(m.charAt(ende))) ende--;
    var kern = m.slice(start, ende + 1);
    var dez = kern.length >= 3 ? kern.charAt(kern.length - 3) : '';
    var hatDez = /\D/.test(dez);
    var ohneDez = hatDez ? kern.slice(0, kern.length - 3) : kern;
    var g = ohneDez.match(/\D/);
    return {
      vor: m.slice(0, start),
      nach: m.slice(ende + 1),
      dez: hatDez ? dez : ',',
      gruppe: g ? g[0] : '',
      nachkomma: hatDez ? 2 : 0
    };
  }

  function format(w) {
    var muster = w.getAttribute('data-sx-mr-geld') || '';
    if (!(muster in formate)) formate[muster] = formatLesen(muster);
    return formate[muster];
  }

  function geld(cent, f) {
    if (!f) return (cent / 100).toFixed(2).replace('.', ',') + ' €';
    var wert = f.nachkomma ? (cent / 100).toFixed(2) : String(Math.round(cent / 100));
    var teile = wert.split('.');
    var ganz = f.gruppe ? teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.gruppe) : teile[0];
    return f.vor + ganz + (f.nachkomma ? f.dez + teile[1] : '') + f.nach;
  }

  // ---------------------------------------------------------------- Preise / Rechnen
  // Die Preistabelle wird bei jedem Lauf frisch gelesen statt gecacht: Bei verbundenen
  // Produkten morpht Horizon den ganzen Bereich aus der Serverantwort — dann steht dort
  // ein anderes Produkt mit anderen Varianten-IDs.
  function basisCent(w) {
    var s = w.querySelector('[data-sx-mr-preise]');
    if (!s) return 0;
    var tabelle;
    try { tabelle = JSON.parse(s.textContent); } catch (e) { return 0; }
    var feld = variantenfeld();
    if (feld && feld.value && tabelle[feld.value]) return tabelle[feld.value];
    return tabelle[w.getAttribute('data-sx-mr-start')] || 0;
  }

  // Exakt dieselbe Rechnung wie im Snippet: Nachlass kaufmaennisch gerundet auf die ZEILE
  // (Preis mal Menge), nicht je Stueck — so rechnet auch Shopifys automatischer Rabatt,
  // und die angezeigte Ersparnis passt zu der im Warenkorb.
  function rechnen(basis, menge, rabatt) {
    var brutto = basis * menge;
    var nachlass = Math.round((brutto * rabatt) / 100);
    var gesamt = brutto - nachlass;
    return { nachlass: nachlass, gesamt: gesamt, je: Math.round(gesamt / menge) };
  }

  function einheit(w, anzahl) {
    return anzahl === 1
      ? (w.getAttribute('data-sx-mr-e1') || 'Stück')
      : (w.getAttribute('data-sx-mr-en') || 'Stück');
  }

  // ---------------------------------------------------------------- Menge setzen
  function setzeMenge(menge) {
    var feld = mengenfeld();
    if (!feld) return;

    // Horizons eigene Grenzen einhalten (component-quantity-selector.js, getEffectiveMax):
    // min, step und "Lagerbestand minus das, was schon im Warenkorb liegt". Wer hier
    // darueber hinaus setzt, bekommt beim Klick auf Kaufen eine Fehlermeldung — und wer
    // das Raster (step) verletzt, dessen Wert schnappt Horizon beim naechsten Blur zurueck.
    var min = zahl(feld.min, 1);
    var step = Math.max(1, zahl(feld.step, 1));
    var max = zahl(feld.max, null);
    var imKorb = zahl(feld.getAttribute('data-cart-quantity'), 0);
    if (menge < min) menge = min;
    if ((menge - min) % step !== 0) menge = min + Math.ceil((menge - min) / step) * step;
    if (max !== null) menge = Math.min(menge, Math.max(max - imKorb, min));

    eigenerSchreibvorgang = true;
    feld.value = String(menge);
    feld.dispatchEvent(new Event('input', { bubbles: true }));
    feld.dispatchEvent(new Event('change', { bubbles: true }));
    eigenerSchreibvorgang = false;

    // Zwei Nachbarn fuehren die Menge selbst und erfahren von einem gesetzten value NICHTS:
    // 1. quantity-selector.liquid bindet NUR on:blur="/setQuantity" — ein gefeuertes
    //    change-Ereignis erreicht die Komponente also gar nicht. Ohne den expliziten
    //    Aufruf bleibt der Minus-Knopf nach einem Sprung von 1 auf 4 grau.
    // 2. Die mobile Kaufleiste zaehlt ausschliesslich ueber quantity-selector:update mit
    //    (sticky-add-to-cart.js). Ohne dieses Ereignis landen zwar vier Stueck im
    //    Warenkorb, auf dem Knopf steht aber weiter "(1)" — und das ist auf 375 px die
    //    sichtbarste Flaeche ueberhaupt. Das Ereignis traegt bewusst KEIN cartLine:
    //    daran erkennen Kaufleiste und Warenkorb-Komponente, dass es sie nichts angeht.
    var komp = feld.closest ? feld.closest('quantity-selector-component') : null;
    if (komp) {
      if (typeof komp.updateButtonStates === 'function') {
        try { komp.updateButtonStates(); } catch (e) {}
      }
      komp.dispatchEvent(new CustomEvent('quantity-selector:update', {
        bubbles: true,
        detail: { quantity: menge }
      }));
    }

    malen();
  }

  // ---------------------------------------------------------------- Zeichnen
  // Spiegelt die TATSAECHLICHE Menge aus dem Kaufformular in die Staffel. Diese Richtung
  // ist die wichtigere: Der Kunde darf die Menge auch mit dem Plus-Knopf oder von Hand
  // setzen, und die Staffel muss dann trotzdem zeigen, wo er steht.
  function stufenLesen(w, basis, f) {
    var zeilen = w.querySelectorAll('[data-sx-mr-stufe]');
    var stufen = [];
    var vorherJe = basis;

    for (var i = 0; i < zeilen.length; i++) {
      var el = zeilen[i];
      var m = zahl(el.getAttribute('data-menge'), 1);
      var r = zahl(el.getAttribute('data-rabatt'), 0);
      var feld = el.querySelector('[data-sx-mr-je]');

      if (m <= 1) {
        el.hidden = false;
        if (feld) feld.textContent = geld(basis, f);
        stufen.push({ m: 1, r: 0, el: el });
        continue;
      }

      // Preis-Waechter, jetzt gegen den Preis der GEWAEHLTEN Variante: Eine Stufe, die
      // keinen Cent spart oder denselben Stueckpreis wie die Stufe davor ergibt, wird
      // nicht gezeigt. Beim Variantenwechsel kann sich das aendern — 3 % auf 0,99 EUR
      // sind null, auf 39,99 EUR nicht.
      var k = rechnen(basis, m, r);
      var zeigen = k.nachlass > 0 && k.je < vorherJe;
      el.hidden = !zeigen;
      if (zeigen) {
        vorherJe = k.je;
        if (feld) feld.textContent = 'je ' + geld(k.je, f);
        stufen.push({ m: m, r: r, el: el });
      }
    }
    return stufen;
  }

  function aktivFuer(stufen, menge) {
    var aktiv = null;
    for (var i = 0; i < stufen.length; i++) {
      if (stufen[i].m <= menge && (!aktiv || stufen[i].m > aktiv.m)) aktiv = stufen[i];
    }
    return aktiv;
  }

  function malen() {
    var widgets = document.querySelectorAll('[data-sx-mr]');
    if (!widgets.length) return;

    var feld = mengenfeld();
    var menge = feld ? zahl(feld.value, 1) : 1;
    if (menge < 1) menge = 1;

    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var basis = basisCent(w);
      if (!basis) continue;
      var f = format(w);

      var stufen = stufenLesen(w, basis, f);
      var aktiv = aktivFuer(stufen, menge);
      var naechste = null;
      var k;
      for (k = 0; k < stufen.length; k++) {
        if (stufen[k].m > menge && (!naechste || stufen[k].m < naechste.m)) naechste = stufen[k];
      }

      // Markiert wird die erreichte Stufe, nicht eine "Auswahl". Weil die Zeilen mit
      // "ab N" beschriftet sind, stimmt das bei JEDER Menge — auch bei 3 zwischen den
      // Stufen 2 und 4. Damit steht nie eine leere Auswahl ueber dem Kaufen-Knopf.
      for (k = 0; k < stufen.length; k++) {
        var radio = stufen[k].el.querySelector('.sx-mr__radio');
        if (radio) radio.checked = aktiv !== null && stufen[k].m === aktiv.m;
      }

      var bilanz = w.querySelector('[data-sx-mr-bilanz]');
      if (!bilanz) continue;
      var satz = '';
      var oben = false;

      if (naechste) {
        var fehlt = naechste.m - menge;
        var kn = rechnen(basis, naechste.m, naechste.r);
        satz = 'Noch <b>' + fehlt + ' ' + esc(einheit(w, fehlt)) + '</b> mehr: <b>' +
          naechste.r + ' %</b> Rabatt — du sparst <b>' + geld(kn.nachlass, f) + '</b>.';
      } else if (aktiv && aktiv.r > 0) {
        oben = true;
        k = rechnen(basis, menge, aktiv.r);
        satz = '<b>Bestpreis</b> — ' + menge + ' ' + esc(einheit(w, menge)) + ' für <b>' +
          geld(k.gesamt, f) + '</b>, ' + geld(k.nachlass, f) + ' gespart.';
      }

      bilanz.innerHTML = satz;
      bilanz.classList.toggle('sx-mr__bilanz--top', oben);
      bilanz.hidden = satz === '';
    }
  }

  // Nach einem Neu-Rendern kommen die Radios im Serverzustand zurueck (disabled), und
  // gemorphtes Markup fuehrt keine Skripte aus — der Dreizeiler im Snippet greift dann
  // nicht mehr. Idempotent, laeuft deshalb bei jedem Durchgang mit.
  function alles() {
    var widgets = document.querySelectorAll('[data-sx-mr]');
    for (var i = 0; i < widgets.length; i++) {
      widgets[i].classList.add('sx-mr--js');
      var r = widgets[i].querySelectorAll('.sx-mr__radio[disabled]');
      for (var k = 0; k < r.length; k++) r[k].disabled = false;
    }
    malen();
  }

  // Der Variantenwechsel meldet sich, BEVOR input[name="id"] und der Kaufblock aktualisiert
  // sind (variant-picker.js feuert das Ereignis vor dem fetch). Deshalb dreimal nachfassen
  // statt einmal — dieselbe Falle wie bei der UVP-Zeile.
  function nachfassen() {
    alles();
    setTimeout(alles, 80);
    setTimeout(alles, 400);
  }

  // Delegiert am Dokument statt an den Zeilen: Nach einem Neu-Rendern des Kaufblocks waeren
  // direkt gesetzte Zuhoerer weg, ein delegierter ueberlebt jedes Morphen.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    if (t.classList && t.classList.contains('sx-mr__radio')) {
      var w = t.closest('[data-sx-mr]');
      // Die Stueckzahl-Staffel (data-sx-st) nutzt DIESELBE Radio-Klasse fuer dieselbe Optik,
      // aber ihre Zeilen wechseln die VARIANTE, nicht die Menge — sie gehoeren dem Modul
      // darunter. Ohne diesen Guard setzte ein Klick auf "4 Stueck" zusaetzlich die Menge
      // auf 4 (beim Livetest am 26.08. lagen ploetzlich 4 Packs = 16 Melder im Korb).
      if (!w) return;
      var ziel = zahl(t.value, 1);
      var feld = mengenfeld();
      var jetzt = feld ? zahl(feld.value, 1) : 1;

      // Die Stufenzeilen sind SCHWELLEN ("ab 2"), kein Mengenwaehler — deshalb heben sie die
      // Menge nur an, nie ab. Wer bei 5 steht, erfuellt "ab 2" bereits; ein Klick darauf darf
      // ihm nicht drei Stueck wegnehmen. Vorher hing das am Zufall: Bei Menge 3 blieb die 3
      // stehen, bei Menge 5 fiel sie auf 2 — derselbe Klick, zwei Ergebnisse (25.08. von der
      // Abnahme-Zusicherung gefunden). Ausgenommen ist die erste Zeile: "1 Stück" ist keine
      // Schwelle, sondern der Ausgangszustand, und muss zuruecksetzen koennen.
      if (w && ziel > 1 && jetzt >= ziel) { malen(); return; }

      setzeMenge(ziel);
      // Damit sich nach dem Umbau ueberhaupt messen laesst, ob die Staffel wirkt — die
      // AOV-App hinterliess dazu keine Zahl. Kostet nichts und stoert nichts, wenn es
      // keinen dataLayer gibt.
      try {
        document.dispatchEvent(new CustomEvent('sx:staffel:wahl', {
          bubbles: true, detail: { menge: ziel, rabatt: zahl(t.closest('[data-sx-mr-stufe]').getAttribute('data-rabatt'), 0) }
        }));
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'sx_staffel_wahl', sx_menge: ziel });
        }
      } catch (e2) {}
      return;
    }

    if (t.name === 'quantity') { if (!eigenerSchreibvorgang) malen(); return; }

    // Jeder andere Wechsel im Kaufblock kann ein Variantenwechsel sein (Radios des
    // Variantenwaehlers, Dropdown).
    if (!eigenerSchreibvorgang) nachfassen();
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity' && !eigenerSchreibvorgang) malen();
  }, true);

  // Der Plus/Minus-Waehler feuert KEIN natives input/change, sondern nur sein eigenes
  // Ereignis (component-quantity-selector.js, QuantitySelectorUpdateEvent).
  document.addEventListener('quantity-selector:update', function () {
    if (!eigenerSchreibvorgang) malen();
  });

  // Das Standardereignis des Themes fuer den Variantenwechsel — es blubbert bis zum
  // Dokument (product-price.js haengt sich an die Sektion).
  document.addEventListener('shopify:product:select', function () { nachfassen(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
  else alles();

  // Faengt das serverseitige Neu-Rendern ab: Danach stehen die Radios wieder auf disabled
  // und die Zahlen auf dem Stand der Startvariante.
  if (typeof window.sxBeobachten === 'function') window.sxBeobachten(alles, '.product-details');
})();
